// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"ShortcutTooltip__tooltipContainer___H9tmq","shortcutContainer":"ShortcutTooltip__shortcutContainer___Lf5yb"};